"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CalendarFilledIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M19 5h.005C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5H5v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2V5h6v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2z"/><path fill="inherit" d="M7 13h2v-2H7zm0 4h2v-2H7zm4-4h2v-2h-2zm0 4h2v-2h-2zm4-4h2v-2h-2zm0 4h2v-2h-2z"/><path fill="currentcolor" d="M16 6V5h2v1a1 1 0 0 1-2 0m0-2a1 1 0 0 1 2 0v1h-2zM6 4a1 1 0 0 1 2 0v1H6zm0 2V5h2v1a1 1 0 0 1-2 0"/></g></svg>`
}, props));
CalendarFilledIcon.displayName = 'CalendarFilledIcon';
var _default = exports.default = CalendarFilledIcon;